import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { PageContainer } from "@/components/page-container";
import { TableContainer } from "@/components/table-container";
import { Table } from "@renderbus/ui";
import { useWatchPagination } from "@/components/dynamic-form/hook/useWatchPagination";
import { useNormalColumns } from "@/pages/payment/hooks/useNormalColumns";
import { useGlobalStore } from "@/store/GlobalStore";
import { usePaymentStore } from "../../store/payment-store";
import { RechargeRecordTabType } from "../../constants";
import { useEffect } from "react";

export function NormalRechargeRecord() {
  const { tableData, pageNum, fetchData, setPageNum, total, pageSize } =
    useDynamicForm({
      api: "/api/rendering/pay/recharge/rechargeList",
      defaultPageSize: 10,
    });
  const { isDomestic, isSubAccount } = useGlobalStore();
  const { activeTabKey } = usePaymentStore();

  useWatchPagination(pageSize, pageNum, fetchData);

  useEffect(() => {
    if (activeTabKey === RechargeRecordTabType.Normal) {
      fetchData();
    }
  }, [activeTabKey, fetchData]);

  const { columns } = useNormalColumns({ isDomestic, isSubAccount });
  return (
    <PageContainer>
      <TableContainer>
        <Table
          paginationCurrent={pageNum}
          columns={columns}
          dataSource={tableData}
          gap={false}
          total={total}
          defaultPageSize={pageSize}
          onPageNumChange={async (num) => {
            setPageNum(num);
          }}
        />
      </TableContainer>
    </PageContainer>
  );
}
